/**
 * EmptyState & LoadingState - The Intelligent Standard
 *
 * Clean empty and loading states with proper typography.
 */

import { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      {icon && (
        <div className="mb-4" style={{ color: '#A0A0A0' }}>
          {icon}
        </div>
      )}
      <h3
        className="font-serif text-2xl font-medium mb-2"
        style={{ color: '#1A1A1A' }}
      >
        {title}
      </h3>
      {description && (
        <p className="max-w-md" style={{ color: '#6B6B6B' }}>
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      <div className="flex items-center gap-3" style={{ color: '#6B6B6B' }}>
        <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
            strokeDasharray="60"
            strokeDashoffset="20"
            opacity="0.3"
          />
        </svg>
        <span>{message}</span>
      </div>
    </div>
  );
}
